// * Default padding bottom os pages
// * Hack to Fixed Menu in bottom pages

export const PADDING_BOTTOM_PAGE = "2.875rem"